module.exports = __webpack_public_path__ + "img/c_1.2ceea8ae.jpg";